export const getInitialTab = () => {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 11) return { category: "meals", type: "breakfast" };
  if (hour >= 11 && hour < 13) return { category: "snacks", type: "afternoon" };
  if (hour >= 13 && hour < 17) return { category: "meals", type: "lunch" };
  if (hour >= 17 && hour < 19) return { category: "snacks", type: "evening" };
  if (hour >= 19 && hour <= 23) return { category: "meals", type: "dinner" };

  return { category: "meals", type: "breakfast" };
};
